import {
	TRASH_LIST_GENERIC_ACTIVITY_LIST_SORT,
	TRASH_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/trashList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SerializedQuery } from 'src/models/query';
import { TrashListItem } from 'src/models/trashList';

interface TrashListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	directionFilter: 'combined' | 'in' | 'out';
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	today: string;
	trashListAll: Array<TrashListItem>;
	trashListAllSliced: Map<number, Array<TrashListItem>>;
	trashListAllTotalCount: number;
	trashListMine: Array<TrashListItem>;
	trashListMineSliced: Map<number, Array<TrashListItem>>;
	trashListMineTotalCount: number;
	trashListOpen: Array<TrashListItem>;
	trashListOpenSliced: Map<number, Array<TrashListItem>>;
	trashListOpenTotalCount: number;
}

function state(): TrashListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		directionFilter: 'combined',
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(TRASH_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(TRASH_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(TRASH_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(TRASH_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		today: new Date().toISOString().split('T')[0],
		trashListAll: [],
		trashListAllSliced: new Map<number, Array<TrashListItem>>(),
		trashListAllTotalCount: 0,
		trashListMine: [],
		trashListMineSliced: new Map<number, Array<TrashListItem>>(),
		trashListMineTotalCount: 0,
		trashListOpen: [],
		trashListOpenSliced: new Map<number, Array<TrashListItem>>(),
		trashListOpenTotalCount: 0,
	};
}

export default state;
